import { Injectable, Injector } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AlertService } from '../../shared/alert/alert.service';

/**
 * Surfaces backend authorization errors (403) to the user by showing the API's
 * own message. This covers modules that cannot be fully hidden in the UI: when
 * the user reaches a forbidden action, the API response is displayed instead of
 * a silent failure. The error is re-thrown so callers can still react.
 */
@Injectable()
export class ForbiddenInterceptor implements HttpInterceptor {
  // AlertService is resolved lazily (only when a 403 is caught) to avoid a
  // construction-time DI cycle: AlertService -> TranslateService -> HttpClient
  // -> HTTP_INTERCEPTORS (this) -> AlertService. Injecting it in the constructor
  // forces that chain to hydrate during HttpClient setup and throws NG0200.
  constructor(private injector: Injector) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((error: unknown) => {
        if (error instanceof HttpErrorResponse && error.status === 403) {
          this.injector.get(AlertService).showError(this.resolveMessage(error), 'Acceso denegado');
        }
        return throwError(() => error);
      })
    );
  }

  private resolveMessage(error: HttpErrorResponse): string {
    const backend = (error.error ?? {}) as {
      message?: string;
      error?: { message?: string; details?: { message?: string } };
      details?: { message?: string };
    };
    return (
      backend.message ||
      backend.error?.message ||
      backend.error?.details?.message ||
      backend.details?.message ||
      'No tienes permisos para realizar esta acción.'
    );
  }
}
